import { ToastContainer } from 'react-toastify';
import '../node_modules/react-toastify/dist/ReactToastify.min.css';
import './App.css';
import RoutesMain from './Routes';

function App() {
  return (
    <div className="App">
        <RoutesMain />
        <ToastContainer/>
    </div>
  );
}



export default App;
